import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaExchangeAlt } from "react-icons/fa";
import { MdPendingActions } from "react-icons/md";
import { GiProgression } from "react-icons/gi";
import { BsBarChartFill } from "react-icons/bs";
import { CgProfile } from "react-icons/cg";
import useSize from "../../../Utils/useSize/useSize";

export default function BottomNavBar() {
  const location = useLocation();
  const navigate = useNavigate();

  const windowSize = useSize();

  const tabs = [
    {
      key: "pending",
      label: "Pending",
      icon: <MdPendingActions />,
      path: "/Pending",
    },
    {
      key: "standing",
      label: "Standing",
      icon: <GiProgression />,
      path: "/Standing",
    },
    {
      key: "quotes",
      label: "Quotes",
      icon: <FaExchangeAlt />,
      path: "/Watchlist",
    },
    {
      key: "trade",
      label: "Trade",
      icon: <BsBarChartFill />,
      path: "/Trade",
    },
    {
      key: "profile",
      label: "Profile",
      icon: <CgProfile />,
      path: "/Profile",
    },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 flex border-t-2 border-[var(--hover)] justify-center z-30">
      <div
        style={{ width: windowSize[0] }}
        className="
        flex items-center justify-between py-2 
        bg-[var(--background)]]/10 backdrop-blur-lg
        transition-all duration-300 "
      >
        {tabs.map((tab) => {
          const isActive =
            (tab.key === "quotes" &&
              (location.pathname === "/" || location.pathname === "/Watchlist")) ||
            location.pathname === tab.path;

          return (
            <button
              key={tab.key}
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center justify-center flex-1 py-1 text-[11px] sm:text-[12px]
                font-medium transition-all duration-200 ease-in-out
                ${isActive
                  ? "text-[var(--primary)] scale-110 drop-shadow-[0_0_15px_rgba(59,130,246,0.6)]"
                  : "text-[var(--text)]"
                }`}
            >
              <div
                className={`text-lg sm:text-xl mb-[2px] transition-all duration-200 ${isActive ? "scale-110" : "opacity-80"
                  }`}
              >
                {tab.icon}
              </div>
              <span className="tracking-wide">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
